import React from "react";
import { ModalShell } from "./ModalShell";
import { BASE_URLS } from "../../config/urls";

export function NeedCompaniesModal({
                                       isOpen,
                                       onClose,
                                   }: {
    isOpen: boolean;
    onClose: () => void;
}) {
    if (!isOpen) return null;

    return (
        <ModalShell
            title="Добавьте компанию"
            subtitle="Без данных о компании нельзя создать заявку"
            onClose={onClose}
        >
            <div style={{ marginTop: 6 }} className="profile-muted">
                У вас пока нет заполненных компаний. Добавьте ИП/ООО в личном кабинете — и после этого сможете записаться.
            </div>

            <div className="profile-modal-actions" style={{ marginTop: 16 }}>
                <button className="btn-secondary" type="button" onClick={onClose}>
                    Закрыть
                </button>

                <button
                    className="btn-primary"
                    type="button"
                    style={{boxShadow: "none"}}
                    onClick={() => window.location.assign(`${BASE_URLS.app}/personal-account`)}
                >
                    Перейти в личный кабинет
                </button>
            </div>
        </ModalShell>
    );
}
